import AppPlateFormLogos from "components/appplateformlogos";
import Header from "components/global/header";
import { cn } from "lib/utlis";

export default function HeroBanner({
  showAppLogoInHeader = false,
  bgStyles,
  sectionClassName,
  heroBannerImgUrl,
  mainWrapperClassName,
  titleWrapperClassName,
  description,
  descriptionWrapperClassName,
  titleClassName,
  title,
  showAppLogos = false,
}) {
  return (
    <>
      <Header showAppPlatformLogo={showAppLogoInHeader} />
      <section
        className={cn("py-36", sectionClassName)}
        style={{
          ...bgStyles,
          backgroundImage: `url(${heroBannerImgUrl})`,
          backgroundSize: "cover",
        }}
      >
        <div className={cn("container", mainWrapperClassName)}>
          <div className={cn("max-w-xl w-full ab", titleWrapperClassName)}>
            <h1
              className={cn(
                "text-white text-5xl mb-8 lg:text-7xl lg:leading-tight font-anton",
                titleClassName
              )}
            >
              {title}
            </h1>
              <p
                className={cn(
                  "text-xl font-semibold text-white italic mx-auto lg:max-w-2xl",
                  descriptionWrapperClassName
                )}
              >
                {description}
              </p>
            {showAppLogos && <AppPlateFormLogos />}
          </div>
        </div>
      </section>
    </>
  );
}
